// Temporary user-facing feature switches. Change a value to true to restore
// both navigation access and its route without touching the feature code.
export const academyFeatures = Object.freeze({
  paymentHistory: false,
  courseQuiz: true,
  courseCertificate: true,
});
